<template>
  <div class="computerContainer">
    <div class="cable">
      <div class="plug">
        <div class="socket"></div>
      </div>
      <svg>
        <path d="M 300 200 Q 250 268 300 250 Q 351 229 350 250 Q 350 300 400 300 " />
      </svg>
    </div>
    <a 
      target="_blank"
      :href="computer.ExternalLink"
      class="computer"
      :class="{
        active: computer,
        animate: animate
      }"
    >
      <div class="base"></div>
      <div class="lid">
        <div class="logo"></div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "Computer",
  props: [
    'computer',
  ],
  mounted() {
    setInterval(() => {this.animate = !this.animate}, 20000)
  },
  data () {
    return {
      animate: false
    }
  },
}
</script>

<style>
.computerContainer {
  position: absolute;
  left: 870px;
  top: 40px;
  z-index: 1;
}
.computerContainer .cable {
  transform-origin: top right;
  transform: skewX(70deg);
  position: absolute;
  left: -980px;
  bottom: -60px;
  pointer-events: none;
}
.computerContainer .cable .plug {
  position: absolute;
  height: 10px;
  width: 8px;
  top: 173px;
  left: 258px;
  border-radius: 1px;
  border: 0.5px solid rgb(158, 158, 158);
  background: lightgrey;
  display: flex;
  justify-content: center;
  align-items: center;
}
.computerContainer .cable .plug .socket {
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: var(--wall-socket-grey);
}
.computerContainer .cable svg {
  height: 300px;
  width: 400px;
  transform: scale(0.6);
}
.computerContainer .cable svg path {
  fill: transparent;
  stroke: var(--cable-grey);
  stroke-width: 2px;
  stroke-linecap: round;
}
.computerContainer a.computer {
  width: 60px;
  height: 10px;
  cursor: default;
}
.computerContainer a.computer.active {
  cursor: pointer;
}
.computerContainer a.computer .base {
  width: 60px;
  height: 10px;
  background: var(--computer-dark-grey);
  border-right: 3px solid rgb(173, 173, 173);
}
.computerContainer a.computer .lid {
  position: absolute;
  width: 60px;
  height: 38px;
  background: linear-gradient(to bottom, var(--thirty-grey), var(--twenty-grey));
  transform-origin: top right;
  transform: skewX(67deg) rotateX(180deg);
  border-top: 2px ridge var(--twenty-grey);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.5s ease;
}
.computerContainer a.computer.active .lid:hover {
  transform: skewX(70deg) rotateX(180deg) scaleY(1.15);
  transition: transform 0.5s ease;
}
.computerContainer a.computer.active.animate .lid {
  animation: 2s ease alternate openComputer;
}
@keyframes openComputer {
  0% {  transform: skewX(67deg) rotateX(180deg) }
  50% { transform: skewX(70deg) rotateX(180deg) scaleY(1.15) }
  100% {  transform: skewX(67deg) rotateX(180deg) }
}
.computerContainer .computer .lid .logo {
  height: 6px;
  width: 6px;
  border-radius: 10px;
  background: var(--computer-dark-grey);
}

</style>


